// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/file-chart-column-increasing.js';

import { paths } from '../generated/file-chart-column-increasing';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('file-chart-column-increasing', Original, paths);
